import React from 'react';
import { AppSettings, getAppSettings } from '../pm/appSettings';

export interface HSSApplicationContext {
    applicationSettings: AppSettings;
}

// @ts-ignore
export const ApplicationStateContext = React.createContext<HSSApplicationContext>();

interface HSSInfrastructureProviderProps {
    children: any;
}

export const HSSInfrastructureProvider: React.FC<HSSInfrastructureProviderProps> = ({ children }) => {
    const contextValue = {
        applicationSettings: getAppSettings()
    };

    return <ApplicationStateContext.Provider value={contextValue}>{children}</ApplicationStateContext.Provider>;
};

